module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _c('a', {
    attrs: {
      "id": "contents"
    }
  }), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 1")]), _c('br'), _c('big', [_vm._v("THE BEGINNING")])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 2")]), _c('br'), _c('big', [_vm._v("THE PRIMITIVES")])], 1)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 3")]), _c('br'), _c('big', [_vm._v("THE RIVALS")])], 1)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 4")]), _c('br'), _c('big', [_vm._v("DUELS IN CHINA")])], 1)]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 5")]), _c('br'), _c('big', [_vm._v("THE ICONS")])], 1)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 6")]), _c('br'), _c('big', [_vm._v("THE BUTCHER BIRDS")])], 1)]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 7")]), _c('br'), _c('big', [_vm._v("ON THE ATTACK")])], 1)]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 8")]), _c('br'), _c('big', [_vm._v("THE BRUISERS")])], 1)]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 9")]), _c('br'), _c('big', [_vm._v("THE RADICALS")])], 1)]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "contents"
    }
  }, [_vm._v("CONTENTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#preface"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PREFACE")]), _c('br'), _vm._v("THE FLYING HERITAGE COLLECTION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")]), _c('br'), _vm._v("TECHNOLOGY OVER TIME")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("CURTISS JN-4D JENNY"), _c('br'), _vm._v("POLIKARPOV U-2 (PO-2) LIGHT NIGHT BOMBER")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("POLIKARPOV I-16 TYPE 24 RATA"), _c('br'), _vm._v("HAWKER HURRICANE MK.XII")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("MESSERSCHMITT BF 109 E-3"), _c('br'), _vm._v("SUPERMARINE SPITFIRE F.MK.VC")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("CURTISS P-40C TOMAHAWK"), _c('br'), _vm._v("NAKAJIMA KI-43 HAYABUSA OSCAR TYPE I")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("MITSUBISHI A6M3-22 REISEN (ZERO)"), _c('br'), _vm._v("NORTH AMERICAN P-51D MUSTANG")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("FOCKE-WULF FW 190 A-5"), _c('br'), _vm._v("FOCKE-WULF FW 190 D-13")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("FIESELER FI 156 C-2 STORCH"), _c('br'), _vm._v("ILYUSHIN IL-2M3 SHTURMOVIK"), _c('br'), _vm._v("NORTH AMERICAN B-25J MITCHELL")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("REPUBLIC P-47D THUNDERBOLT"), _c('br'), _vm._v("GRUMMAN F6F-5 HELLCAT")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("MESSERSCHMITT ME 163 B-1 KOMET"), _c('br'), _vm._v("MESSERSCHMITT ME 262 A-1A")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/about#about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknow#acknow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo#photo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IMAGE CREDITS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocchapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0